module.exports = __webpack_public_path__ + "static/media/9-34.d5225501.svg";